module.exports = __webpack_public_path__ + "img/mlbb-banner.d2766c8.png";